import {
  convertDecimalToFraction,
  checkMeasurementSpecOutOfTolerance,
  displayOutOfTolValue,
} from '@/utils/common'
import { find } from 'lodash'
import './ReportMeasurement.style.less'

const SAMPLES_PER_TABLE = 5

interface Props {
  data: any
  measurementUnit: string
  sampleSize?: number
}

function ReportMeasurement(props: Props) {
  const isInch = props.measurementUnit == 'in'
  const totalSamples = props.sampleSize ?? SAMPLES_PER_TABLE

  const tablePages: number[][] = []
  for (let i = 0; i < totalSamples; i += SAMPLES_PER_TABLE) {
    const page: number[] = []
    for (let j = i + 1; j <= i + SAMPLES_PER_TABLE; j++) {
      page.push(j)
    }
    tablePages.push(page)
  }

  return (
    <>
      {tablePages.map((samplesInPage, pageIndex) => (
        <div
          key={pageIndex}
          className="report-measurement-container"
          style={pageIndex > 0 ? { marginTop: 16 } : {}}
        >
          {/* Table header */}
          <div className="report-measurement-header-container">
            <p className="header-left">POM</p>
            <p className="header">Tol+/-</p>
            <p className="header">Spec.</p>
            {samplesInPage.map((sampleNum) => (
              <p key={sampleNum} className="header">
                {sampleNum <= totalSamples ? `Sample ${sampleNum}` : ''}
              </p>
            ))}
          </div>

          {/* Table rows */}
          {props.data.map((item, key) => (
            <div
              key={key}
              className="report-measurement-value-container report-page-break"
            >
              <p className="value-left">{item.pom}</p>
              <p className="value">
                +
                {isInch
                  ? convertDecimalToFraction(item.plus_tolerance)
                  : item.plus_tolerance}
                /-
                {isInch
                  ? convertDecimalToFraction(item.minus_tolerance)
                  : item.minus_tolerance}
              </p>
              <p className="value">
                {isInch ? convertDecimalToFraction(item.spec) : item.spec}
              </p>
              {samplesInPage.map((sampleNum) => {
                if (sampleNum > totalSamples) {
                  return <p key={sampleNum} className="value"></p>
                }

                const data = find(
                  item.value,
                  (d) => d.sample === `sample${sampleNum}`
                )?.value
                const isOutOfTolerance = checkMeasurementSpecOutOfTolerance(
                  data,
                  item.spec,
                  item.plus_tolerance,
                  item.minus_tolerance
                )
                return (
                  <p
                    key={sampleNum}
                    className="value"
                    style={{
                      color: isOutOfTolerance ? '#C03261' : '',
                      fontSize: isInch ? 16 : 15,
                    }}
                  >
                    {displayOutOfTolValue(
                      data,
                      item.spec,
                      props.measurementUnit
                    ).replace('--', '-')}
                  </p>
                )
              })}
            </div>
          ))}
        </div>
      ))}
    </>
  )
}

export default ReportMeasurement
